/**
 * ******************************************************
 * Copyright (C) 2021 VMware, Inc. All rights reserved.
 * *******************************************************
 *
 * @format
 */

import { EventEmitter, Output, Directive, Input } from "@angular/core";
import { AbstractModalComponent } from "./abstract-modal.component";

@Directive()
export class AbstractModalComponentWithInputText extends AbstractModalComponent {
   public static readonly BUTTON_KEY = "buttonName";

   @Input()
   public inputTextData: string;

   public updateText(inputText: string) {
      this.inputTextData = inputText;
   }

   private getResult(buttonName: string) {
      return { BUTTON_KEY: buttonName, INPUT_TEXT: this.inputTextData};
   }

   @Output()
   public eventEntry: EventEmitter<any> = new EventEmitter();

   public confirmModalWithInputText = () => {
      this.eventEntry.emit(this.getResult(AbstractModalComponent.BTN_OK));
   };

   public cancelModalWithInputText = () => {
      this.eventEntry.emit(this.getResult(AbstractModalComponent.BTN_CANCEl));
   };
}
